export var DISPLAY_COUNT = 3;
export var RANDOM_COLORS = ["orangeBox", "", "purpleBox"];